<template>
<nav class="custom-nav">
    <a class="arxiki" href="/">ΑΡΧΙΚΗ</a>
    <Dropdown title="ΠΡΟΪΟΝΤΑ" titlen="ACCOMMODATION" :items="services" :itemsen="servicesen"/>
    <a href="/blog/">BLOG</a>
    <a href="/contact-us/">ΕΠΙΚΟΙΝΩΝΙΑ</a>    
</nav>
</template>
/* eslint no-mixed-spaces-and-tabs: "off" */
<script>
import Dropdown from './Dropdown'
import Products from './Products'

export default{
    name: 'white-navbar',
    components: {
        Dropdown,
        Products
    },
     data () {
        return{
            services: [
                {
                    title: 'DOUBLE LOFT',
                    link: '/double-loft/'
                },
                {
                    title: 'TWIN STANDARD',
                    link: '/twin-standard/'
                },
                {
                    title: 'TRIPLE STANDARD',
                    link: '/triple-standard/'
                },
            ],
            servicesen: [
                {
                    title: 'DOUBLE LOFT',
                    link: '/double-loft/?lang=en'
                },
                {
                    title: 'TWIN STANDARD',
                    link: '/twin-standard/?lang=en'
                },
                {
                    title: 'TRIPLE STANDARD',
                    link: '/triple-standard/?lang=en'
                },
            ],
           
        }
    }

}
</script>
<style >
 nav{
        display: flex;
        align-items: center;
    }
.sidebar-drop{
    position: absolute !important;
    left: 0px;
}
    nav .menu-item{
        color:#fff;
        position: relative;
        text-align:center;
        border-bottom: 3px solid transparent;
        display: flex;
        transition: 0.4s;
    }

    nav .menu-item a{
        color:inherit;
        text-decoration:none;
    }


    /* code */

#tab_container_4545 .wpsm_nav-tabs>li span{
	color:#000 !important;
}


.prod-text .wp-block-buttons{
	display:none !important;
}
.star-rating{
	display:none !important;
}
.skilos h2{
	font-size:35px !important;
}
.wc-block-grid__product, .wpsf-product {
	background: #edfaff !important;
}
/*.imagefull img, .flex-img img{
	border:10px solid #f7741e !important;
}*/
.gb-container-e9732a3e .border-r{
	width:100% !important;
}
.skilos figure{
	background: #1d6aa4d4 !important;
    padding: 10px !important;
    border-radius: 7px !important;
}
.woocommerce ul.products li.product a img{
	height:255px !important;
}
.single .woocommerce-product-gallery{
	margin-top:-25px !important;
}
.main-navigation .main-nav ul li a, .main-navigation .menu-toggle, .main-navigation .menu-bar-items{
	color:#222;
}
.main-navigation .main-nav ul li a:hover{
	color:#1c6aa3 ;
}
.single .woocommerce-product-gallery__image a{
	pointer-events: none !important; 
}
.side-cont {
	height:670px !important;
    overflow-y: scroll;
}
.let{
	margin-top:5px !important;
}
#menu-item-3599{
	display:none !important;
}
.single-product .site{
	padding-top:140px !important;
}
.site-header{
	position:fixed;
	background: #dfdeded1 !important;
	background: url('/wp-content/uploads/2024/06/seamless-pattern-with-poses-jack-russell-terrier-dog-breed-vector-design-illustration-fabric_213585-285-transformed.jpeg'), #dfdeded1 !important;
	backdrop-filter: blur(4px) !important;
	top:0px !important;
	width:100% !important;
	z-index:9999 !important;
	background-size:20% !important;
	background-repeat: repeat !important;
}

.menu-col, .menu-col1{
	padding-left:60px !important;
}
.menu-col,.menu-col2,.menu-col1, .menu-col3, .menu-col4 {
	width:27% !important;
}
.menu-col{
	width:30% !important;
}
.menu-item1 {
	padding-bottom:0px !important;
}
.menu-item1 a{
	font-size:14px !important;
	padding-bottom:0px !important;
}

.sidebar-drop{
	border-radius:20px !important;
	top:70px !important;
}
.side-cont{
	border-radius:20px !important;
	max-width:100% !important;
	margin-left:auto !important;
	margin-right:auto !important;
	margin-bottom:2px !important;
	box-shadow: 1px 3px 3px rgb(0 0 0 / 21%);
	margin-top:45px !important;
}
.menu-col1{
	padding-right:0px !important;
	padding-left:0px !important;
}
.en{
	padding-left:0px !important;
	
}
.menu-last{
	margin-left:-50px !important;
}
.marg{
	margin-top:20px !important;
}
.menu-col4{
	width:25% !important;
	background: url(https://skmetal.anvetogroup.com/wp-content/uploads/2024/10/welding-1.webp) !important;	
	background-size:cover !important;
    height: 100% !important;
    background-attachment: fixed;
}
.sidebar-drop .menu-item1{
	padding:0px !important;
	border-left: 1px solid #1c6aa3;
}
.en .menu-item1{
	padding:0px !important;
	padding-left:0px !important;
	display:flex !important;
}
.en{
	padding-top:30px !important;
}
.menu-item2 strong{
	color: #1c6aa3 !important;
	font-size:17px !important;
}
.menu-item2 strong:hover{
	color: #000 !important;
}
.menu-item2{
	margin-bottom:10px !important;
	margin-top:10px !important;
}
.let{
	margin-top:15px !important;
}
.sidebar-drop .menu-item1{
	margin-left:25px !important;
}
.marg{
	margin-top:20px !important;
}
nav .menu-item svg{
	display:none !important;
}
.main-navigation .main-nav ul li a{
	color: #222;
}
img[data-lazyloaded]{
    opacity: 0;
}

/* PART 2 - Upon Lazy Load */
img.litespeed-loaded{
    -webkit-transition: opacity .5s linear 0.2s;
    -moz-transition: opacity .5s linear 0.2s;
    transition: opacity .5s linear 0.2s;
    opacity: 1;
}

.social img {
    box-shadow: 2px 2px #ceb0a0 !important;
    border-radius: 50%;
}
.rel, .gb-grid-wrapper-918a9989, .wp-block-image{
	position:relative !important;
}
*{
	filter: saturation(1.2) !important;
}
div#n2-ss-2 .nextend-arrow-animated-fade, .wpsp-nav{
	background: #008df8b0 !important;
    padding: 12px !important;
    border-radius: 50% !important;
}
div#n2-ss-2 .nextend-arrow-animated-fade:hover, .wpsp-nav:hover{
	background: #008df8e8 !important;
}
.nextend-arrow-previous img{
	margin-left:-2px !important;
}
.nextend-arrow-next img{
	margin-right:-2px !important;
}
.skalisto {
    color: transparent !important;
    background: #c34300 !important;
    -webkit-background-clip: text !important;
    -moz-background-clip: text !important;
    background-clip: text !important;
    text-shadow: 0 4px 4px rgba(255, 255, 255, .5) !important;
}
.ais-Hits-item h2{
	font-size:18px !important;
}
.ais-Hits-item img{
	background: #fff !important;
	padding:30px !important;
}
.gb-grid-wrapper-f35e2ff7{
	margin-left:20px !important;
}
.search a {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 10px !important;
    border-radius: 10px !important;
    width: 60px !important;
    height: 50px !important;
    background: linear-gradient(to bottom right, #3a7d97, #3a7d97, #77b6ce, #3a7d97, #3a7d97) !important;
}
.search img {
    filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(342deg) brightness(102%) contrast(102%);
}
.search a:hover {
    background: linear-gradient(to bottom right, #144f66, #144f66, #77b6ce, #144f66, #144f66) !important;
}
.gb-container-05b336b2 a {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 10px !important;
    border-radius: 10px !important;
    width: 60px !important;
    height: 50px !important;
    background: linear-gradient(to bottom right, #3a7d97, #3a7d97, #77b6ce, #3a7d97, #3a7d97) !important;
}
.site-header .cart img, #mobile-header .cart img {
    filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(342deg) brightness(102%) contrast(102%);
}
.gb-container-05b336b2 a:hover {
    background: linear-gradient(to bottom right, #144f66, #144f66, #77b6ce, #144f66, #144f66) !important;
}
.lds-dual-ring {
  margin-top:20vh !important;
  display: inline-block;
  width: 80px;
  height: 80px;
}
.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 64px;
  height: 64px;
  margin: 8px;
  border-radius: 50%;
  border: 6px solid #144f66;
  border-color: #144f66 transparent #144f66 transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}

@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.page-id-7152 .site{
	position: relative !important;
	min-height:50vh !important;
}
.load{
    background-color: #fffdfd;
    height: 100%;
    align-items: flex-start;
    justify-content: center;
    display: flex;
    -webkit-animation: fade-out 0.8s ease-out both 0.8s;
    animation: fade-out 0.8s ease-out both 0.8s;
    position: absolute;
    top: 0px;
	left:0px;
    z-index: 999;
    width: 100%;
}
@-webkit-keyframes fade-out {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
	z-index: 0;
  }
}
@keyframes fade-out {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
	z-index: 0;
  }
}
.ais-InstantSearch .left-panel, .algolia-add-cart, .ais-Pagination{
	display:none !important;
}
.ais-InstantSearch{
	justify-content: center !important;
}
.ais-Hits-list, .ais-InfiniteHits-list, .ais-InfiniteResults-list, .ais-Results-list{
	justify-content: center !important;
}
.ais-SearchBox input[type="search"] {
    background: #eafdff !important;
    border-radius: 20px !important;
}
#wps-slider-section #sp-woo-product-slider-4521 .wpsf-cart-button a:not(.sp-wqvpro-view-button):not(.sp-wqv-view-button){
	border:1px solid #1d6aa4 !important;
	color: #1d6aa4 !important;
}
#wps-slider-section #sp-woo-product-slider-4521 .wpsf-product-title a:hover{
	color: #1d6aa4 !important;
}
#wps-slider-section #sp-woo-product-slider-4521 .wpsf-cart-button a:not(.sp-wqvpro-view-button):not(.sp-wqv-view-button):hover{
	color: #fff !important;
	background: #1d6aa4 !important;
}
.wc-block-grid__product{
	border: 1px solid #f6f6f6 !important;
	border-radius:20px !important;
	padding: 15px !important;
}
.wc-block-grid__products{
	gap: 20px !important;
}
.theme-twentytwenty .wc-block-grid.has-4-columns .wc-block-grid__product, .wc-block-grid.has-4-columns .wc-block-grid__product{
	flex: 1 0 23% !important;
}

.wc-block-grid__products .wc-block-grid__product-image img{
	padding:30px !important;
}

.gb-container-33790a67{
	padding-top:40px !important;
	padding-bottom:40px !important;
}
#tab_container_4545 .wpsm_nav-tabs > li.active > a, #tab_container_4545 .wpsm_nav-tabs > li.active > a:hover, #tab_container_4545 .wpsm_nav-tabs > li.active > a:focus{
	background: transparent !important;
}
.home .wc-block-grid__products img{
	mix-blend-mode: multiply !important;
}

#wps-slider-section #sp-woo-product-slider-4539 .wpsf-cart-button a:not(.sp-wqvpro-view-button):not(.sp-wqv-view-button){
	border-radius:20px !important;
}
.wp-block-button__link{
	border-radius: 20px !important;
	box-shadow: 2px 3px 0 0 rgb(144 141 209 / 43%), 0 0 0 5px #fff;
    background: linear-gradient(to bottom right, #3a7d97, #3a7d97, #77b6ce, #3a7d97, #3a7d97) !important;
}
.featured-image{
	display:none !important;
}
.archive #page {
    max-width: 1400px !important;
}

.n2-ss-control-bullet {
    margin-bottom: -30px !important;
}

.home .site-footer {
    margin-top: 0px !important;
}

.woocommerce ul.products li.product .button {
    background: linear-gradient(to bottom right, #c67246, #c67246, #d8a488, #c67246, #c67246) !important;
    border-radius: 20px !important;
    box-shadow: 2px 3px 0 0 rgb(144 141 209 / 43%), 0 0 0 5px #fff;
}

.woocommerce ul.products li.product .woocommerce-LoopProduct-link h2,
.woocommerce ul.products li.product .woocommerce-loop-category__title {
    font-size: 18px !important;
}

.woocommerce #content div.product div.images,
.woocommerce div.product div.images,
.woocommerce-page #content div.product div.images,
.woocommerce-page div.product div.images {
    width: 40% !important;
}

.separate-containers .inside-article,
.separate-containers .comments-area,
.separate-containers .page-header,
.separate-containers .paging-navigation,
.one-container .site-content,
.inside-page-header {
    padding-bottom: 70px;
}

.woocommerce-tabs,
.related {
    display: none !important;
}

.woocommerce div.product .product_title {
    font-size: 30px !important;
    color: #1c6aa3 !important;
}

.wc-menu-item {
    display: flex;
    color: #fff !important;
    justify-content: center;
    align-items: center;
    margin-left: 10px !important;
    border-radius: 10px !important;
    width: 60px !important;
    height: 50px !important;
    background: linear-gradient(to bottom right, #3a7d97, #3a7d97, #77b6ce, #3a7d97, #3a7d97) !important;
}

.wc-menu-item:hover {
    color: #fff !important;
    background: linear-gradient(to bottom right, #144f66, #144f66, #77b6ce, #144f66, #144f66) !important;
}

.wc-menu-item a {
    padding-left: 0px !important;
    padding-right: 0px !important;
}

.wc-menu-item svg {
    font-size: 17px !important;
}

.wc-menu-item:hover a {
    color: #fff !important;
}

.woocommerce ul.products li.product .button:hover {
    background: linear-gradient(to bottom right, #a35730, #a35730, #d8a488, #a35730, #a35730) !important;
}

.product-category,
#wc-column-container .product {
    background: #e4e4e4;
    padding: 25px !important;
    border-radius: 5px !important;
    box-shadow: 0 7px 12px rgb(235 246 255) !important;
}

.woocommerce ul.products li.product a img {
    background: #FFF !important;
    box-shadow: -5px 11px 12px rgb(62 62 62 / 44%) !important;
    border-radius: 5px !important;
    padding: 30px !important;
}

#wps-slider-section #sp-woo-product-slider-4521 .wpsf-cart-button a:not(.sp-wqvpro-view-button):not(.sp-wqv-view-button) {
    border-radius: 20px !important;
    padding: 9px 18px !important;
    margin-top: 20px !important;
}

#wps-slider-section .wps-product-section .swiper-button-prev {
    left: -50px !important;
}

.wpsf-product .wpsf-cart-button a {
    display: none !important;
}

.wpsf-product {
    margin-bottom: 10px !important;
    padding: 15px !important;
    border: 1px solid #f6f6f6 !important;
    border-radius: 20px !important;
    height: 370px !important;
}

.wpsf-product:hover {
    box-shadow: 0 3px 12px -3px rgba(30, 30, 30, .35);
}

.wpsf-product:hover .wpsf-cart-button a {
    display: block !important;
}

.flex-img {
    display: flex !important;
    gap: 20px !important;
    margin-top: 20px !important;
    margin-bottom: 20px !important;
}

.flex-img img {
    border-radius: 20px !important;
    height: 450px !important;
    object-fit: cover !important;
}

.flex-img .wp-block-image {
    width: 50% !important;
}

.wpcf7-form input[type=email],
.wpcf7-form input[type=text],
.wpcf7-form textarea,
.wpcf7-tel {
    width: 100% !important;
    border-radius: 20px !important;
}

form p {
    color: #fff !important;
}

.wpcf7-submit,
.aitima a {
    border-radius: 20px !important;
    background: linear-gradient(to bottom right, #c67246, #c67246, #d8a488, #c67246, #c67246) !important;
    box-shadow: 2px 3px 0 0 rgb(144 141 209 / 43%), 0 0 0 5px #fff;
}

.wpcf7-submit:hover {
    background: linear-gradient(to bottom right, #a35730, #a35730, #d8a488, #a35730, #a35730) !important;
}

#map {
    height: 618px;
    width: 100%;
    margin: auto;
    border-radius: 10px !important;
}

.footer-right a:hover {
    color: #c67246 !important;
}

.wpsm_nav {
    display: flex !important;
    justify-content: center !important;
}

.border-r img {
    border-radius: 10px !important;
}

.page-id-3589 .site-footer {
    margin-top: 0px !important;
}

.gb-grid-wrapper-cc6f8966 p {
    margin-bottom: 0px !important;
}

.gb-grid-wrapper-cc6f8966 {
    align-items: center !important;
}

body {
    padding: 0px !important;
}

.wpsm_nav {
    border-bottom: 1px solid #e6e6e6 !important;
}

#sp-wp-tabs-wrapper_4542.sp-tab__lay-default>.sp-tab__tab-content .sp-tab__tab-pane {
    border: 0px solid !important;
}

#tab_container_4545 .wpsm_nav-tabs>li {
    width: 17% !important;
}

#tab_container_4545 .tab-content {
    border-left: 0px solid !important;
}

.sp-tab__tab_title {
    font-size: 22px !important;
}

.prod-text {
    padding-top: 60px !important;
    display: flex !important;
}

.imagefull {
    width: 100% !important;
}

.prod-text h2,
.prod-text .wp-block-buttons {
    width: 50% !important;
}

.prod-text .wp-block-buttons {
    text-align: right;
}

#sp-wp-tabs-wrapper_4542.sp-tab__lay-default>ul>li label,
#sp-wp-tabs-wrapper_4542.sp-tab__lay-default>ul>li a,
#sp-wp-tabs-wrapper_4542.sp-tab__lay-default>ul>.sp-tab__nav-item {
    border: 0px solid !important;
}

.footer-right p {
    margin-bottom: 2px !important;
}



.wpsm_nav-tabs li:first-child i {
    background: url('/wp-content/uploads/2024/06/dog-icon.png') !important;
    background-size: cover !important;
}

.wpsm_nav-tabs li:nth-child(2) i {
    background: url('/wp-content/uploads/2024/06/cat-icon.png') !important;
    background-size: cover !important;
}
#wps-slider-section #sp-woo-product-slider-4539.wps-product-section .wpsp-nav{
	border:0px solid !important;
}
.fa-laptop:before {
    opacity: 0 !important;
}

.wpsm_nav-tabs li i {
    width: 40px !important;
    height: 40px !important;
}

#tab_container_4545 .wpsm_nav-tabs>li>a {
    display: flex !important;
    align-content: center !important;
    align-items: center !important;
    justify-content: center !important;
    font-size: 22px !important;
}

#tab_container_4545 .wpsm_nav-tabs>li>a {
    background: transparent !important;
    border-bottom: 1px solid #e6e6e6 !important;
}

#tab_container_4545 .wpsm_nav-tabs,
#tab_container_4545 .wpsm_nav-tabs>li,
#tab_container_4545 .wpsm_nav-tabs>li>a {
    border: 0px solid !important;
}

#tab_container_4545 .wpsm_nav-tabs>li span {
    font-size: 22px !important;
    color: #000 !important;
    margin-left: 8px !important;
}

#sp-wp-tabs-wrapper_4542>.sp-tab__nav-tabs>.sp-tab__nav-item.show .sp-tab__nav-link,
#sp-wp-tabs-wrapper_4542>.sp-tab__nav-tabs>.sp-tab__nav-item .sp-tab__nav-link.sp-tab__active,
#sp-wp-tabs-wrapper_4542.sp-tab__lay-default label>.sp-tab__card-header {
    background: transparent !important;
}

.sp-tab__nav-link,
#sp-wp-tabs-wrapper_4542.sp-tab__lay-default>ul .sp-tab__nav-item,
#sp-wp-tabs-wrapper_4542.sp-tab__lay-default label.collapsed>.sp-tab__card-header {
    background: transparent !important;
}

#sp-wp-tabs-wrapper_4542 .sp-tab__nav-tabs .sp-tab__nav-item.show .sp-tab__nav-link,
#sp-wp-tabs-wrapper_4542.sp-tab__lay-default ul li label.sp-tab__active {
    border: 0px solid !important;
}

#sp-wp-tabs-wrapper_4542.sp-tab__lay-default ul li label.sp-tab__active {
    border: 2px solid #1c6aa3 !important;
	border-radius:5px !important;
}

#tab_container_4545 .wpsm_nav-tabs>li.active>a,
#tab_container_4545 .wpsm_nav-tabs>li.active>a:hover,
#tab_container_4545 .wpsm_nav-tabs>li.active>a:focus {
    border: 2px solid #1c6aa3 !important;
}
#tab_container_4545 .wpsm_nav-tabs>li a{
	border-radius:5px !important;
}
#tab_container_4545 .wpsm_nav-tabs>li:hover>a {
}

* {
    font-family: 'ZonaPro';
}

div#n2-ss-2 .nextend-bullet-bar .n2-bullet.n2-active {
    padding: 5px 13px !important;
}

.swiper-button-next {
    top: 50% !important;
    right: 0px !important;
    background: rgba(173, 173, 173, .5) !important;
    width: 40px !important;
    height: 40px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    border-radius: 50px !important;
}

#wps-slider-section .wps-product-section .wpsp-nav {
    width: 40px !important;
    height: 40px !important;
}

#wps-slider-section .wps-product-section .wpsp-nav {
    font-size: 35px !important;
    line-height: 40px !important;
}

#wps-slider-section.wps-slider-section .wpsp-nav i.fa {
    margin-top: -4px !important;
}

.fa-angle-left {
    margin-right: 2px !important;
    color: #fff !important;
}

.fa-angle-right {
    margin-left: 2px !important;
    color: #fff !important;
}

#wps-slider-section #sp-woo-product-slider-4521.wps-product-section .wpsp-nav {
    border: 0px solid !important;
}
#wps-slider-section #sp-woo-product-slider-4521.wps-product-section .wpsp-nav:hover{
	transform: scale(1.15) !important;
}
#wps-slider-section .wps-product-section .swiper-button-prev {
    left: 0px !important;
    top: 50% !important;
    background: rgba(173, 173, 173, .5) !important;
    width: 40px !important;
    height: 40px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    border-radius: 50px !important;
}

#wps-slider-section .wps-product-section {
    padding: 10px !important;
}

#wps-slider-section img.wpsf-product-img {
    padding: 10px !important;
}

.skilos .wps-product-image {
    border: 0px solid !important;
}

div#n2-ss-2 .n2-style-eea254e0b2767b42b224b25eec2d6876-dot:HOVER {
    padding: 6px !important;
}

.n2-ss-slider-2 {
    border-radius: 10px !important;
}

.imagefull figure,
.imagefull img {
    width: 100% !important;
    object-fit: cover !important;
    
}
.imagefull img{
border-radius: 20px !important;	
}
.skilos h2 {
    margin-bottom: 0px !important;
}

.line-h {
    line-height: 60px !important;
}

.sign {
    font-family: 'nf-petitnuage-regular' !important;
}

.border img {
    border-radius: 20px !important;
}

.logos .wp-block-image {
    border: 1px solid #1c6aa3 !important;
	background: #e6f8ffdb !important;
	backdrop-filter: blur(4px) !important; 
    border-radius: 10px !important;
}

.wppsac-post-content-position {
    position: absolute !important;
    top: 0px !important;
    left: 0px !important;
    width: 100% !important;
    padding: 80px !important;
}

.wppsac-carousel-slides {
    position: relative !important;
}

.wppsac-post-categories-list {
    display: none !important;
}

.wppsac-post-date span {
    display: none !important;
}

.wppsac-post-date {
    font-size: 14px !important;
}

.wppsac-post-title a {
    display: none !important;
}

.wppsac-sub-content {
    line-height: 50px !important;
    font-size: 40px !important;
    color: #fff !important;
}

.wppsac-post-date,
.wppsac-readmorebtn {
    color: #fff !important;
    border: none !important;
}

.wppsac-readmorebtn:hover {
    background: transparent !important;
}

.slick-next {
    background: #a71d54!important;
    border-radius: 50%!important;
    color: #a71d54!important;
    width: 55px !important;
    height: 55px !important;
    background: url(/wp-content/uploads/2023/05/blog_slider.png)!important;
    background-size: 60% !important;
    background-repeat: no-repeat !important;
    border: 2px solid #0A1928 !important;
    background-position: center center !important;
    margin-right: -60px !important;
}

.slick-next svg {
    display: none !important;
}

.slick-prev {
    background: #a71d54!important;
    border-radius: 50%!important;
    color: #a71d54!important;
    width: 55px !important;
    height: 55px !important;
    background: url(/wp-content/uploads/2023/05/blog_slider_left.png)!important;
    background-size: 60% !important;
    background-repeat: no-repeat !important;
    border: 2px solid #0A1928 !important;
    background-position: center center !important;
    margin-left: -60px !important;
}

.slick-prev svg {
    display: none !important;
}

.wppsac-post-carousel.design-1 .wppsac-carousel-slides,
.wppsac-post-carousel.design-1 .wppsac-post-image-bg,
.wppsac-post-content-position,
.slick-slide img {
    min-height: 520px !important;
    border-radius: 20px !important;
}

.wppsac-post-carousel.design-1 .slick-dots {
    display: none !important;
}

.wppsac-readmorebtn {
    font-size: 0px !important;
}

.wppsac-readmorebtn::after {
    content: 'Όλο το άρθρο';
    font-size: 14px;
}

.footer-widgets-container {
    display: none !important;
}

.poweredby {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #000 !important;
}

.poweredby p {
    margin: 0;
    line-height: 16px;
}

.poweredby svg,
.poweredby img {
    width: 200px;
    height: auto;
    margin-left: 10px !important;
    transform: scale(1.0);
    filter: invert(50%) sepia(59%) saturate(527%) hue-rotate(336deg) brightness(91%) contrast(81%) !important;
}

body::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px !important;
    background: #F5F5F5;
}

body::-webkit-scrollbar {
    border-radius: 10px;
    width: 12px;
    background-color: linear-gradient(90deg #95654b 0%, #95654b 25%, #daad94 50%, #95654b 75%, #95654b 100%);
}

body::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
    border-radius: 10px !important;
    background: linear-gradient(to bottom, #95654b, #daad94, #95654b);
    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.5)
}

.inside-header {
    padding-bottom: 10px !important;
}

.site-header{
    background: #dfdeded1 !important;
}
/*.site-header:before{
	content: "";
    background-image: url(/wp-content/uploads/2024/06/seamless-pattern-with-poses-jack-russell-terrier-dog-breed-vector-design-illustration-fabric_213585-285-transformed.jpeg);
    background-position: center center;
    background-size:50% !important;
	background-repeat: repeat !important;
    background-attachment: fixed;
    z-index: 0;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transition: inherit;
    pointer-events: none;
    opacity: 0.1;
}*/
.site-header .inside-navigation,
.main-navigation,
.main-navigation ul ul{
	background: transparent !important;
}
.wp-block-button__link:hover{
	background: linear-gradient(to bottom right, #144f66, #144f66, #77b6ce, #144f66, #144f66) !important;
}
.style-svg:hover {
    transform: scale(1.1);
}
#generate-slideout-menu{
	background: #5294c4eb !important;
}
.home .wp-block-product-category .wp-block-button__link{
	background: transparent !important;
	color:#1d6aa4 !important;
	border:1px solid #1d6aa4 !important;
}
.home .wp-block-product-category .wp-block-button__link:hover{
	background: #1d6aa4 !important;
	color:#fff !important;
	border:1px solid #1d6aa4 !important;
}
.wp-block-product-category .wp-block-button {
	opacity:0;
}
.wp-block-product-category .wc-block-grid__product:hover {
    box-shadow: 0 3px 12px -3px rgba(30, 30, 30, .35);
}
.wp-block-product-category .wc-block-grid__product:hover .wp-block-button {
    opacity:1;
}
@media (max-width: 1600px) {
	.menu-item1 a{
		font-size:13px !important;
	}
}
@media (max-width: 1550px) {
	.menu-item1 a{
		font-size:11px !important;
	}
}
@media (max-width: 1450px) {
	.menu-col, .menu-col1{
		padding-left: 30px !important;
	}
}
@media (max-width: 1300px) {
	.menu-col, .menu-col1{
		padding-left: 15px !important;
	}
	.menu-item2 strong{
		font-size:14px !important;
	}
	.wpsf-product{
		height:450px !important;
	}
	.menu-col{
		padding-left:10px !important;
	}
}
@media (max-width: 1200px) {
	.wpsf-product{
		height:450px !important;
	}
	.wpsf-product{
		height:480px !important;
	}
}
@media (max-width: 1200px) {
	.menu-col{
		padding-top:0px !important;
	}
	.wpsf-product{
		height:460px !important;
	}
}
@media (max-width: 1100px) {
	#tab_container_4545 .wpsm_nav-tabs>li {
		width: 25% !important;
	}
	.side-cont{
		margin-top:35px !important;
	}
}
@media (max-width: 1024px) {
	#tab_container_4545 .wpsm_nav-tabs>li {
    	width: 33% !important;
	}
	.gb-container-e9732a3e figure{
		width:100% !important;
	}
	.gb-grid-wrapper > .gb-grid-column-15509c86, .gb-grid-wrapper > .gb-grid-column-e9732a3e{
		width:100% !important;
	}
}
@media (max-width: 992px) {
	.wpsf-product{
		height:550px !important;
	}
	.theme-twentytwenty .wc-block-grid.has-4-columns .wc-block-grid__product, .wc-block-grid.has-4-columns .wc-block-grid__product{
	    flex: 1 0 45% !important;
		max-width:45% !important;
	}
}

@media (max-width: 900px) {
	.menu-col{
		padding-left:10px !important;
		padding-right:10px !important;
	}
	.main-navigation a, .main-navigation .menu-toggle, .main-navigation .menu-bar-items{
		font-size:12px !important;
	}
	.wpsf-product{
		height:530px !important;
	}
	.site-header .header-image{
		width:150px !important;
	}
	.gb-grid-wrapper-f35e2ff7{
		margin-left:0px !important;
	}
	.main-navigation .main-nav ul li a, .menu-toggle, .main-navigation .menu-bar-item > a{
		padding-left:10px !important;
		padding-right:10px !important;
	}
	.menu-item2 strong{
		font-size:13px !important;
	}
}
@media (max-width: 768px) {
	.skilos h2, .skalisto{
		font-size:25px !important;
	}
	#mobile-header{
		background: #dfdeded1 !important;
		    backdrop-filter: blur(4px) !important;
	}
	.single .woocommerce-product-gallery{
		margin-top:0px !important;
	}
	.gb-container-e9732a3e figure{
		width:100% !important;
	}
	.gb-container-e24ec8c8{
		padding-top:120px !important;
	}
	.gb-headline-82e657e9, h1.gb-headline-a480d372{
		font-size:25px !important;
	}
	.single-product .site{
		padding-top:20px !important;
	}
	.gb-container-d6262bcd{
		padding-top:120px !important;
	}
	#menu-item-3599{
		display:block !important;
	}
	.home-wp{
		display:none !important;
	}
	nav .menu-item{
		justify-content: center !important;
	}
	.main-navigation.navigation-stick.has-sticky-branding .inside-navigation.grid-container{
		padding-left:20px !important;
		padding-right:20px !important;
	}
	.gb-grid-wrapper-fa31d605 > .gb-grid-column{
		width:50% !important;
	}
	.wpsf-product{
		height:auto !important;
	}
	.slideout-navigation.main-navigation .main-nav ul li a{
		border-radius:20px !important;
		padding:0px 20px !important;
	}
	.gb-grid-wrapper-1074189b .gb-grid-column{
		width:33% !important;
	}
	.gb-container-cba3fbbc img{
		height:400px !important;
	}
	.gb-grid-wrapper > .gb-grid-column-178b4e75, .gb-grid-wrapper > .gb-grid-column-40b59d80{
		width:50% !important;
	}
	.gb-grid-wrapper-1074189b img{
		width:250px !important;
	}
	.gb-grid-wrapper-f35e2ff7{
		margin-left:20px !important;
	}
	.gb-grid-wrapper-f35e2ff7{
		position: absolute !important;
		right:80px !important;
	}
	.gb-grid-wrapper-f35e2ff7{
		flex-direction:row !important;
	}
	.gb-grid-wrapper > .gb-grid-column-f3b00d64{
		width:50% !important;
	}
	.gb-grid-wrapper > .gb-grid-column-05b336b2{
		width:50% !important;
	}
	.flex-img img{
		height:300px !important;
	}
	.wp-image-4422{
		height:400px !important;
	}
	.gb-container-ab70145a > .gb-inside-container{
		padding:40px 10px !important;
	}
	h2.gb-headline-d2b3a680{
		font-size:25px !important;
	}
	.gb-container-9e89a7dc > .gb-inside-container{
		padding-bottom:0px !important;
	}
	.woocommerce #content div.product div.images, .woocommerce div.product div.images, .woocommerce-page #content div.product div.images, .woocommerce-page div.product div.images{
		width:100% !important;
	}
    .main-navigation .site-logo.navigation-logo img, .mobile-header-navigation .site-logo.mobile-header-logo img, .navigation-search input[type="search"] {
        height: 90px !important;
    }
	.navigation-branding img, .site-logo.mobile-header-logo{
		height:90px !important;
	}
	.main-navigation.has-branding .inside-navigation.grid-container{
		padding:5px !important;
		padding-left:10px !important;
		padding-right:10px !important;
	}
}
@media (max-width: 600px) {
	.skilos figure{
		padding:10px !important;
	}
	.wc-block-grid__products .wc-block-grid__product-image img{
		padding:5px !important;
	}
	.wc-block-grid.has-4-columns .wc-block-grid__product{
		padding-top:0px !important;
	}
	.gb-grid-wrapper-1074189b .gb-grid-column{
		width:50% !important;
	}
	.gb-grid-wrapper-1074189b img{
		width:200px !important;
	}
	.gb-container-cba3fbbc img{
		height:350px !important;
	}
	.theme-twentytwenty .wc-block-grid.has-4-columns .wc-block-grid__product, .wc-block-grid.has-4-columns .wc-block-grid__product{
	    flex: 1 0 100% !important;
		max-width:100% !important;
	}
	.flex-img img{
		height:200px !important;
	}
	.wp-image-4422{
		height:300px !important;
	}
	#tab_container_4545 .wpsm_nav-tabs>li{
		width:50% !important;
	}
}
@media (max-width: 500px) {
	.gb-container-eb0f2979{
		padding-left:10px !important;
		padding-right:10px !important;
	}
	.gb-container-33790a67 img{
		width:80px !important;
	}
	.skilos h2{
		font-size:22px !important;
	}
	.gb-container-cba3fbbc img{
		height:300px !important;
	}
	.gb-grid-wrapper > .gb-grid-column-178b4e75, .gb-grid-wrapper > .gb-grid-column-40b59d80{
		width:100% !important;
	}
	.wp-container-core-buttons-is-layout-1.wp-container-core-buttons-is-layout-1{
		justify-content: center !important;
	}
	.gb-container-40b59d80{
		text-align: center !important;
	}
	.gb-grid-wrapper-918a9989{
		gap:20px !important;
	}
	h2.gb-headline-d2b3a680{
		font-size:20px !important;
	}
	.search img{
		width:15px !important;
	}
	.site-header .cart img, #mobile-header .cart img{
		width:20px !important;
	}
	.search a, .gb-container-05b336b2 a{
		width:50px !important;
	}
	.gb-grid-wrapper-f35e2ff7{
		right:70px !important;
	}
	.gb-container-fa7ece6d{
		padding-left:10px !important;
		padding-right:10px !important;
	}
	.wpsm_nav-tabs li i{
		width:30px !important;
		height:30px !important;
	}
	#tab_container_4545 .wpsm_nav-tabs>li span{
		font-size:19px !important;
	}
	.prod-text{
		flex-direction:column !important;
		align-items: center;
		gap:20px !important;
	}
	.prod-text h2, .prod-text .wp-block-buttons{
		width:90% !important;
	}
	.prod-text .wp-block-buttons{
		text-align:center !important;
	}
	.prod-text h2{
		text-align:center !important;
		font-size:25px !important;
	}
	.gb-container-5010fa4a{
		padding-left:10px !important;
		padding-right:10px !important;
	}
	.flex-img img{
		height:150px !important;
	}
	.wp-image-4422{
		height:250px !important;
	}
}
@media (max-width: 450px) {
	.gb-container-cba3fbbc img{
		height:250px !important;
	}
}
@media (max-width: 400px) {
	.wp-image-4422{
		height:200px !important;
	}
	.gb-container-fa7ece6d{
		padding-left:10px !important;
		padding-right:10px !important;
	}
	.wpsm_nav-tabs li i{
		width:25px !important;
		height:25px !important;
	}
	#tab_container_4545 .wpsm_nav-tabs>li span{
		font-size:17px !important;
	}
}
@media (max-width: 360px) {
	.wpsm_nav-tabs li i{
		width:22px !important;
		height:22px !important;
	}
	#tab_container_4545 .wpsm_nav-tabs>li span{
		font-size:16px !important;
	}
}
@media (max-width: 340px) {
	.wpsm_nav-tabs li i{
		width:20px !important;
		height:20px !important;
	}
	#tab_container_4545 .wpsm_nav-tabs>li span{
		font-size:14px !important;
	}
}
.white-left{
	position:absolute;
	top:100px !important;
	left:100px !important;
	font-size:40px !important;
	font-weight:500 !important;
	color:#fff !important;
	text-align:left !important;
	text-shadow: -2px 3px #1d6aa4 !important;
}
.white-left-half{
	position:absolute;
	top:50px !important;
	left:50px !important;
	font-size:30px !important;
	font-weight:500 !important;
	color:#fff !important;
	text-align:left !important;
	text-shadow: -2px 3px #1d6aa4 !important;
}
.white-right{
	background: #fff !important;
	width:500px !important;
	height:500px !important;
	position:absolute;
	bottom:-240px !important;
	right:-240px !important;
	border-radius:50% !important;
}
.white-right img{
	width:250px !important;
	margin-right: 125px !important;
    margin-top: -20px !important;
	position:relative;
	z-index:2;
}
.second-img{
	position:absolute !important;
	left:-10px !important;
	z-index:1 !important;
	transform: rotate(342deg);
}
.white-right-half{
	background: #fff !important;
	width:300px !important;
	height:300px !important;
	position:absolute;
	bottom:-150px !important;
	right:-150px !important;
	border-radius:50% !important;
}
.white-right-half img{
	width:175px !important;
	height:auto !important;
	margin-left:5px !important;
	margin-top:-30px !important;
}
@media (max-width: 1200px) {
	.menu-col, .sidebar-drop .el{
		width:35% !important;
	}
	.menu-col, .menu-col1 {
		padding-top:0px !important;
	}
}
@media (max-width: 1100px) {
	.sidebar-drop a{
		line-height:20px !important;
	}
}

#app4 #slide0,
#app4 #slide1,
#app4 #slide2,
#app4 #slide3,
#app4 #slide4 {
    background: transparent !important;
    text-align: center;
    max-width: 60%;
}

#app4 .card_vue1 {
    height: 200px !important;
}

#app4 .card_vue1 p {
    color: #fff !important;
}

.hero-header {
    position: absolute !important;
    top: 57% !important;
    left: 50% !important;
    width: 100% !important;
    transform: translate(-50%, -50%);
}

.slide-in-bottom {
    -webkit-animation: slide-in-bottom 0.8s cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.3s both;
    animation: slide-in-bottom 0.8s cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.3s both;
}

.slide-in-bottom1 {
    -webkit-animation: slide-in-bottom1 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s both;
    animation: slide-in-bottom1 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s both;
}

.slide-in-bottom2 {
    -webkit-animation: slide-in-bottom2 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) 1s both;
    animation: slide-in-bottom2 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) 1s both;
}

.slide-in-bottom3 {
    -webkit-animation: slide-in-bottom3 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) 1.5s both;
    animation: slide-in-bottom3 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) 1.5s both;
}

@-webkit-keyframes slide-in-bottom {
    0% {
        -webkit-transform: translateY(-1000px);
        transform: translateY(-1000px);
        opacity: 0;
    }
    100% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
        opacity: 1;
    }
}

@keyframes slide-in-bottom {
    0% {
        -webkit-transform: translateY(1000px);
        transform: translateY(1000px);
        opacity: 0;
    }
    100% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
        opacity: 1;
    }
}


/**/

@-webkit-keyframes slide-in-bottom1 {
    0% {
        -webkit-transform: translateX(1000px);
        transform: translateX(1000px);
        opacity: 0;
    }
    100% {
        -webkit-transform: translateX(0);
        transform: translateX(0);
        opacity: 1;
    }
}

@keyframes slide-in-bottom1 {
    0% {
        -webkit-transform: translateX(1000px);
        transform: translateX(1000px);
        opacity: 0;
    }
    100% {
        -webkit-transform: translateX(0);
        transform: translatex(0);
        opacity: 1;
    }
}

@-webkit-keyframes slide-in-bottom2 {
    0% {
        -webkit-transform: translateX(-1000px);
        transform: translateX(-1000px);
        opacity: 0;
    }
    100% {
        -webkit-transform: translateX(0);
        transform: translateX(0);
        opacity: 1;
    }
}

@keyframes slide-in-bottom2 {
    0% {
        -webkit-transform: translateX(-1000px);
        transform: translateX(-1000px);
        opacity: 0;
    }
    100% {
        -webkit-transform: translateX(0);
        transform: translateX(0);
        opacity: 1;
    }
}

@-webkit-keyframes slide-in-bottom3 {
    0% {
        -webkit-transform: translateY(1000px);
        transform: translateY(1000px);
        opacity: 0;
    }
    100% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
        opacity: 1;
    }
}

@keyframes slide-in-bottom3 {
    0% {
        -webkit-transform: translateY(1000px);
        transform: translateY(1000px);
        opacity: 0;
    }
    100% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
        opacity: 1;
    }
}


/* parallax */

.small1 {
    height: 750px;
    position: relative;
    background-size: cover;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    background-image: linear-gradient(45deg, rgb(120 120 120 / 47%), rgb(120 120 120 / 47%)), url('/wp-content/uploads/2023/02/heron1.png');
    background-size: cover !important;
    background-position: bottom !important;
}

.small1 h2 {
    font-family: Romantic !important;
    text-align: center !important;
    color: #fff !important;
}

.img {
    width: 300px;
    height: 300px;
}

.flex {
    display: flex;
    height: 750px;
    justify-content: center;
    align-content: center;
    align-items: center;
}

.flex1 {
    display: flex;
    height: 750px;
    justify-content: flex-end;
    align-content: center;
    align-items: center;
}

.small1 h1 {
    color: #fff;
    text-align: center;
    font-size: 45px;
    letter-spacing: 2px !important;
    z-index: 9999;
    font-weight: 500 !important;
}

.small1 p {
    text-align: center !important;
    font-size: 25px !important;
    letter-spacing: 2px;
    color: #fff;
    font-family: 'BPreplayItalics' !important;
}

.second-text p,
.second-text h1 {
    font-size: 25px !important;
}


/* 3d carousel */

.prev {
    background-image: url(/wp-content/uploads/2022/11/angle-left.png);
    width: 40px!important;
    height: auto!important;
    display: inline-block!important;
    background-position: center;
    background-size: cover;
    filter: invert(13%) sepia(63%) saturate(6893%) hue-rotate(329deg) brightness(74%) contrast(121%);
}

.prev span,
.next span {
    opacity: 0 !important;
}

.next {
    background-image: url(/wp-content/uploads/2022/11/right-arrow-angle.png);
    filter: invert(13%) sepia(63%) saturate(6893%) hue-rotate(329deg) brightness(74%) contrast(121%);
    width: 40px!important;
    height: auto!important;
    display: inline-block!important;
    background-position: center;
    background-size: cover;
}

.carousel_3d figure,
.carousel_3d img {
    height: 100%;
    object-fit: cover;
}

#app4 {
    height: 200px !important;
}

.carousel_3d {
    padding: 200px 100px 100px 100px !important;
}

.carousel-3d-slide {
    border-radius: 20px !important;
}

.carousel_3d figcaption {
    position: absolute;
    color: #000;
    bottom: 0;
    position: absolute;
    bottom: 0;
    padding: 15px;
    font-size: 20px;
    text-align: center;
    font-family: 'PFBagueRoundPro-Regular' !important;
    min-width: 100%;
    box-sizing: border-box;
    background-color: rgb(220 247 245 / 68%);
    backdrop-filter: blur(8px);
}

.carousel-3d-slide,
.carousel_3d figure,
.carousel_3d img {
    border-radius: 20px;
}

@media only screen and (max-width: 1400px) {
    .carousel_3d {
        padding: 200px 50px 100px 50px !important;
    }
}

@media only screen and (max-width: 767px) {
    .carousel_3d,
    .small1,
    .flex {
        height: 650px !important;
    }
    .hero-header {
        width: 100% !important;
    }
    .hero-header h1,
    .hero-header p {
        text-align: center !important;
    }
}

@media only screen and (max-width: 650px) {
    .hero-header h1 {
        font-size: 25px !important;
    }
}

@media only screen and (max-width: 550px) {
    .hero-header h1 {
        font-size: 20px !important;
    }
    #app4 .card_vue1 {
        height: 250px !important;
    }
}

@media only screen and (max-width: 500px) {
    .carousel_3d,
    .small1,
    .flex {
        height: 530px !important;
    }
    .carousel_3d {
        padding: 150px 10px 10px 10px !important;
    }
}

@media only screen and (max-width: 450px) {
    .carousel-item img {
        filter: brightness(0.8);
    }
    .carousel_3d,
    .small1,
    .flex {
        height: 450px !important;
    }
    .carousel_3d {
        padding: 110px 10px 10px 10px !important;
    }
    .hero-header h1 {
        font-size: 18px !important;
    }
    .first-text p {
        font-size: 25px !important;
    }
    .secont-text p {
        font-size: 23px !important;
    }
}

@media only screen and (max-width: 410px) {
    .carousel_3d,
    .small1,
    .flex {
        height: 415px !important;
    }
    .hero-header {
        padding: 20px !important;
    }
}

@media only screen and (max-width: 370px) {
    #app4,
    #app4 .card_vue1 {
        height: 300px !important;
    }
    .carousel_3d {
        height: 400px !important;
    }
    .hero-header h1 {
        font-size: 16px !important;
    }
    .first-text p {
        font-size: 22px !important;
    }
    .secont-text p {
        font-size: 20px !important;
    }
}

@media only screen and (max-width: 350px) {
    .carousel_3d {
        height: 390px !important;
    }
    .hero-header h1 {
        font-size: 15px !important;
    }
    .first-text p {
        font-size: 20px !important;
    }
    .secont-text p {
        font-size: 19px !important;
    }
}


/* custom menu */

.custom-nav {
    display: flex !important;
}

.sidebar .close {
    display: flex !important;
}

nav .menu-item svg {
    width: 10px;
}

.button-menu {
    background: none !important;
    border-radius: 0px!important;
    padding: 0px 20px !important;
    margin: 0px 0px !important;
}

.button-menu svg {
    display: none !important;
}

.button-menu:hover {
    background-color: #2b3185;
}

.menu-btn {
    padding-left: 10px !important;
}

.menu-btn svg {
    margin-right: 10px;
}

nav .menu-item .sidebar {
    background-color: #cce1edd9;
    width: 240px !important;
    height: 370px !important;
    position: absolute;
    z-index: 99;
    top: 70px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    box-shadow: -5px 4px 12px rgb(0 0 0 / 21%);
    overflow-x: hidden;
}


.close {
    background-color: #006ba6 !important;
    padding: 10px;
    margin-bottom: 20px;
    border-bottom: 1px solid #fff;
    justify-content: center;
    display: none !important;
}

.close svg {
    transform: scale(1.2);
    margin-right: 20px;
    margin-left: 10px;
    filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(203deg) brightness(104%) contrast(103%) !important;
}

.close h4 {
    color: #fff;
    margin-bottom: 0px !important;
    font-size: 18px !important;
    line-height: 45px !important;
}

.sidebar .menu-item {
    background-color: transparent;
    color: #686fcf;
    font-size: 15px;
    padding: 5px 10px;
    font-weight: 600;
}

.sidebar .menu-item:last-child {
    margin-bottom: 10px !important;
}

.sidebar .menu-item a {
    width: 100%;
    text-align: left;
    padding: 2px 20px;
    font-size: 15px !important;
    text-align: center;
}

.sidebar .menu-item a {
    transition: none !important;
    color: #000 !important;
}

.sidebar .menu-item a:hover {
    background: #006ba6;
    border-radius: 10px;
    color: #fff !important;
}

.fade-enter-active,
.fade-leave-active {
    transition: all .5s ease-out;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}


/* Carousel */

.hero-header {
    padding: 40px;
    text-align: center !important;
    width: 830px !important;
}

.hero-header h3 {
    text-align: center;
    font-size: 65px !important;
    line-height: 80px;
    margin-bottom: 40px !important;
    font-weight: 100 !important;
    color: #fff !important;
    text-shadow: 2px 2px #657636 !important;
}

.hero-header p {
    text-align: center;
    font-size: 35px !important;
    line-height: 60px;
    font-weight: 100 !important;
    color: #fff !important;
    text-shadow: 2px 2px #657636 !important;
}

.hero-header strong {
    color: #49d5ff !important;
}

#app1 {
    height: 850px !important;
}

.car-section {
    height: 850px !important;
}

.carousel {
    display: flex;
    justify-content: center;
    height: 850px !important;
    cursor: pointer !important;
}

.carousel-item img {
    height: 850px !important;
    width: 100%;
    filter: brightness(0.8) !important;
    object-fit: cover;
}

.carousel-item .wave {
    position: absolute;
    bottom: 0px;
    left: 0px;
    height: 300px !important;
}

.carousel-inner {
    position: relative !important;
    width: 100% !important;
    height: 850px !important;
    overflow: hidden !important;
    cursor: pointer !important;
}

.carousel-control {
    display: flex!important;
    align-items: center;
    background: #fcfff9d1;
    border-radius: 50%;
    display: inline-block;
    position: absolute;
    top: calc(55% - 25px);
    cursor: pointer;
    padding: 10px 10px !important;
    width: 100px;
    height: 100px;
}

#app1 .carousel-control {
    box-shadow: 2px 2px #757575 !important;
}

.carousel-control:hover,
.carousel-control:focus {
    background: #e9fad7d1;
}

#app1 svg {
    width: 20px;
    filter: invert(100%) sepia(5%) saturate(7463%) hue-rotate(225deg) brightness(108%) contrast(101%);
}

.carousel-control svg {
    width: 15px!important;
    filter: invert(100%) sepia(5%) saturate(7463%) hue-rotate(225deg) brightness(108%) contrast(101%);
}

.left {
    left: 80px;
}

.right {
    right: 80px;
}


.carousel-indicator-item {
    width: 20px !important;
    height: 20px !important;
    opacity: 0.7;
    border: none;
    border-radius: 50% !important;
    padding: 0px !important;
    background: #fff !important;
    margin: 0.5em;
    cursor: pointer;
}

.active {
    opacity: 1;
}

.slide-fade-enter-active {
    transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
    transform: translateY(-20px);
    opacity: 0;
}


/* */


/* contact */

.contact-flex {
    display: flex;
    z-index: 99;
    position: fixed;
    top: 50% !important;
    right: 0;
    transform: translate(0%, -50%);
    align-items: center;
}

.contact-flex a {
    text-decoration: none;
}

.contact-help {
    width: 75px;
    height: 310px;
    background: #6769becc;
    border-radius: 50px 5px 5px 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    text-decoration: none;
}

.contact-help img {
    padding: 20px 5px;
    width: 65px;
}

.contact-help h3 {
    color: #fff;
    font-size: 18px;
    writing-mode: tb-rl;
    transform: rotate(-180deg);
    margin-bottom: 0px;
    font-weight: 500;
    letter-spacing: 2px;
}

.contact-details {
    background: rgb(49 48 48 / 78%);
    width: 300px;
    height: 260px;
    border-top: 3px solid #7679be;
    border-bottom: 3px solid #7679be;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-right: -300px;
    transition-duration: 1s;
}

.contact-details a {
    display: flex !important;
    align-items: center;
}

.contact-details h3,
.contact-details a {
    color: #fff !important;
    line-height: 40px;
    font-size: 18px;
    text-decoration: none;
    text-align: left;
    margin-left: 10%;
    margin-bottom: 0px !important;
}

.contact-details h3 {
    font-size: 18px;
    font-weight: 600;
    line-height: 75px;
    margin-top: 6%;
    margin-left: 10%;
}

.contact-details a svg {
    margin-right: 20px;
    width: 20px !important;
    filter: invert(80%) sepia(5%) saturate(2223%) hue-rotate(200deg) brightness(102%) contrast(103%);
}

.contact-details a:hover {
    color: #ced0ff !important;
}


/* dropdown*/

.dropdown {
    text-align: center;
}

.button-dropdown {
    text-decoration: none;
    display: inline-block;
    position: relative;
}


/*.button-dropdown:after {
    content: '';
    position: absolute;
    width: 100%;
    transform: scaleX(0);
    height: 1px;
    bottom: 0;
    left: 0;
    background-color: #000;
    transform-origin: bottom right;
    transition: transform 0.25s ease-out;
}*/

.button-dropdown:hover:after {
    transform: scaleX(1);
    transform-origin: bottom left;
}

.dropdown a:hover {
    color: #12608a !important;
}

.btLightSkin .menuHolder .menuPort ul li a:hover,
.btDarkSkin .btLightSkin .menuHolder .menuPort ul li a:hover {
    color: #12608a !important;
}

.button-dropdown svg {
    margin-left: 10px;
    width: 15px !important;
    filter: none !important;
}

.menu-item svg {
    width: 10px !important;
}

.menu-btn {
    padding-left: 10px !important;
}

.sidebar-drop {
    background-color: #fdded7db;
    position: absolute;
    width: 350px !important;
    height: 320px !important;
    z-index: 99;
    
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
    margin-left: auto;
    margin-right: auto;
    text-align: left;
    padding: 1% 0;
    overflow: scroll;
    overflow-x: hidden;
}

.sidebar-drop .menu-item1 {
    color: #686fcf;
    padding: 5px 20px;
    font-weight: 600;
}

.sidebar-drop .menu-item1 a {
    text-align: left;
    text-decoration: none;
    color: #000;
    display: inline-block;
    padding-bottom: 5px;
    position: relative;
}

.sidebar-drop .menu-item1 a:hover {
    color: #4682b4 !important;
}


/*.sidebar-drop .menu-item1 a:after {
    content: '';
    position: absolute;
    width: 100%;
    transform: scaleX(0);
    height: 1px;
    bottom: 0;
    left: 0;
    background-color: #000;
    transform-origin: bottom right;
    transition: transform 0.25s ease-out;
}

.sidebar-drop .menu-item1 a:hover:after {
    transform: scaleX(1);
    transform-origin: bottom left;
}
*/

.sidebar-drop.menu-item1:hover {
    background-color: #fff;
    color: #000;
}

.slide-up-enter-active,
.slide-up-leave-active {
    transition: all 0.4s ease-out;
}

.slide-up-enter,
.slide-up-leave-to {
    opacity: 0;
    transform: translateY(30px);
}

.custom-nav {
    margin-left: 0px !important;
}

.sidebar-drop {
    scrollbar-color: linear-gradient(to bottom, #bea767, #eee, #bea767) !important;
    /* thumb and track color */
    scrollbar-width: thin !important;
}

.sidebar-drop::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px !important;
    background: #eee;
}

.sidebar-drop::-webkit-scrollbar {
    border-radius: 10px;
    width: 12px;
    background-color: linear-gradient(90deg #bea767 0%, #7fbfba 25%, #eee 50%, #7fbfba 75%, #bea767 100%);
}

.sidebar-drop::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
    border-radius: 10px !important;
    background: linear-gradient(to bottom, #bea767, #eee, #bea767);
    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.5)
}

@media only screen and (max-width: 992px) {
    .contact-flex {
        display: none !important;
    }
}

@media only screen and (max-width: 767px) {
    .carousel-control {
        width: 100px;
        height: 100px;
    }
    .carousel_3d figcaption {
        font-size: 20px !important;
    }
    .contact-flex {
        display: none !important;
    }
    #app1 {
        height: 800px !important;
    }
    .car-section {
        height: 800px !important;
    }
    .carousel {
        height: 800px !important;
    }
    .carousel-item img {
        height: 800px !important;
    }
    .carousel-inner {
        height: 800px !important;
    }
    .hero-header {
        width: 400px !important;
    }
}

@media only screen and (max-width: 600px) {
    .carousel-control {
        padding: 5px !important;
    }
    .carousel-control {
        width: 80px;
        height: 80px;
    }
}

@media only screen and (max-width: 450px) {
    .carousel-control {
        width: 60px;
        height: 60px;
    }
    .carousel_3d figcaption {
        font-size: 18px !important;
    }
    #app1 {
        height: 500px !important;
    }
    .car-section {
        height: 500px !important;
    }
    .carousel {
        height: 500px !important;
    }
    .carousel-item img {
        height: 500px !important;
    }
    .carousel-inner {
        height: 500px !important;
    }
}

@media only screen and (max-width: 400px) {
    .contact-details h3 {
        font-size: 20px;
    }
    .contact-details a {
        font-size: 15px;
    }
    .contact-details {
        width: 230px !important;
        margin-right: -230px;
        transition-duration: 0.7s;
    }
    .contact-help {
        width: 60px;
    }
    .contact-help img {
        width: 60px;
        height: auto;
    }
    .carousel-item .wave {
        height: 150px !important;
    }
}


/* vue slick */

.slick-track[data-v-e4caeaf8] {
    position: relative;
    top: 0;
    left: 0;
    display: block;
    -webkit-transform: translateZ(0);
    transform: translateZ(0)
}

.slick-track.slick-center[data-v-e4caeaf8] {
    margin-left: auto;
    margin-right: auto
}

.slick-track[data-v-e4caeaf8]:after,
.slick-track[data-v-e4caeaf8]:before {
    display: table;
    content: ""
}

.slick-track[data-v-e4caeaf8]:after {
    clear: both
}

.slick-loading .slick-track[data-v-e4caeaf8] {
    visibility: hidden
}

.slick-slide[data-v-e4caeaf8] {
    display: none;
    float: left;
    height: 100%;
    min-height: 1px
}

[dir=rtl] .slick-slide[data-v-e4caeaf8] {
    float: right
}

.slick-slide img[data-v-e4caeaf8] {
    display: block
}

.slick-slide.slick-loading img[data-v-e4caeaf8] {
    display: none
}

.slick-slide.dragging img[data-v-e4caeaf8] {
    pointer-events: none
}

.slick-initialized .slick-slide[data-v-e4caeaf8] {
    display: block
}

.slick-loading .slick-slide[data-v-e4caeaf8] {
    visibility: hidden
}

.slick-vertical .slick-slide[data-v-e4caeaf8] {
    display: block;
    height: auto;
    border: 1px solid transparent
}

.slick-arrow.slick-hidden[data-v-21137603] {
    display: none
}

.slick-slider[data-v-3d1a4f76] {
    position: relative;
    display: block;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-touch-callout: none;
    -khtml-user-select: none;
    -ms-touch-action: pan-y;
    touch-action: pan-y;
    -webkit-tap-highlight-color: transparent
}

.slick-list[data-v-3d1a4f76] {
    position: relative;
    display: block;
    overflow: hidden;
    margin: 0;
    padding: 0;
    -webkit-transform: translateZ(0);
    transform: translateZ(0)
}

.slick-list[data-v-3d1a4f76]:focus {
    outline: none
}

.slick-list.dragging[data-v-3d1a4f76] {
    cursor: pointer;
    cursor: hand
}

/* Icons */

@font-face {
    font-family: 'slick';
    src: url(data:application/font-woff;charset=utf-8;base64,d09GRgABAAAAAATsAA0AAAAAB2wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABGRlRNAAAE0AAAABoAAAAcdIcYB0dERUYAAAS0AAAAHAAAAB4AJwANT1MvMgAAAZwAAABRAAAAYFAQ/45jbWFwAAACAAAAAFcAAAFiIhFFt2dhc3AAAASsAAAACAAAAAj//wADZ2x5ZgAAAmgAAAE1AAACLD+btmBoZWFkAAABMAAAAC8AAAA2AAEx+2hoZWEAAAFgAAAAHAAAACQD5QIFaG10eAAAAfAAAAAQAAAAFgZKAEpsb2NhAAACWAAAABAAAAAQATYBoG1heHAAAAF8AAAAHQAAACAASwBHbmFtZQAAA6AAAADcAAABbgUngcJwb3N0AAAEfAAAAC4AAABFOXjBpHjaY2BkYGAA4vMGfuHx/DZfGbiZGEDgfGFFPZxWZVBlvM14G8jlYABLAwAT1QnNAHjaY2BkYGC8zcDAoMfEAAJANiMDKmABADBkAe942mNgZGBgYGdwYWBiAAEQycgAEnMA8xkACcgAkwAAAHjaY2BmYmCcwMDKwMDow5jGwMDgDqW/MkgytDAwMDGwcjKAQQNQCZBSYICCgDTXFAYHhkTFSYwP/j9g0GO8/f82A0QNA+NtsBIFBkYANHMN4wAAAHjaY2KAACYIVoVAAALCAJt42mNgYGBmgGAZBkYGEIgB8hjBfBYGByDNw8DBwARkMzAkKigpTlCc9P8/WB0S7/+i+4/uld4rgZoAB4xsDHAhRiYgwcSApoCBcsBMBTNYGGgGAEdEDyUAAAAAAAAAAAAAZgCKANABFnjadZBdToNAEMd3CrtAl5TQLtS0LCoN0A8SGkBI+mAfPET75B1896HppfQcvnII4w3cLYpW6k4ymdn9z8xvBwEKUQg11OgBIXAYWUEQR1uIZoFGpLGxKy3PqrIq8+waXIfJ+5mQSSvkvXwRqqocu1D39QMl2JgvN9zzhsyk1GRDz+OBfzMioCqx0rtdLYo0SiZTZttsOkmidBkveKibFF4Oep9SI46bqk3Twhp4iihUemrMWFPy2NRbthfqKkHi/PxlJLITZdAiSj6ouZ+tn9eZz78DuD9LZYB6bZ8rlCAUVuVdkULjxV4sIEysIc/KSyPmnJDdjhCOdQ0fCTliTX/tjH3ysWao+71qaNjHQjcQwrcuyl+WLZQthCMotJP/h+Xjazz+hfTeRWmG4zOiSyif/q1OtAAAAHjabY49asNAEIU/2ZJDfkiRIvXapUFCEqpcptABUrg3ZhEiQoKVfY9UqVLlGDlADpAT5e16IUWysMz3hjfzBrjjjQT/EjKpCy+4YhN5yZoxcirPe+SMWz4jr6S+5UzSa3VuwpTnBfc8RF7yxDZyKs9r5IxHPiKv1P9iZqDnyAvMQ39UecbScVb/gJO03Xk4CFom3XYK1clhMdQUlKo7/d9NF13RkIdfy+MV7TSe2sl11tRFaXYmJKpWTd7kdVnJ8veevZKc+n3I93t9Jnvr5n4aTVWU/0z9AI2qMkV42mNgYkAGjAzogB0sysTgwtDOyMTIzJlYVJRfnpOaVsIFZhVlpmeUAABuKQkSAAAAAAAB//8AAnjaY2BkYGDgAWIxIGZiYARCNiBmAfMYAAPgADV42mNgYGBkAIKrS9Q5QPT5wop6GA0APf8GGAAA) format('woff');
}


/* Arrows */

.slick-prev,
.slick-next {
    font-size: 0;
    line-height: 0;
    position: absolute;
    top: 50%;
    display: block;
    width: 20px;
    height: 20px;
    padding: 0;
    -webkit-transform: translate(0, -50%);
    -ms-transform: translate(0, -50%);
    transform: translate(0, -50%);
    cursor: pointer;
    color: transparent;
    border: none;
    outline: none;
    background: transparent;
}

.slick-prev:hover,
.slick-prev:focus,
.slick-next:hover,
.slick-next:focus {
    color: transparent;
    outline: none;
    background: transparent;
}

.slick-prev:hover:before,
.slick-prev:focus:before,
.slick-next:hover:before,
.slick-next:focus:before {
    opacity: 1;
}

.slick-prev.slick-disabled:before,
.slick-next.slick-disabled:before {
    opacity: 0.25;
}

.slick-prev:before,
.slick-next:before {
    font-family: 'slick';
    font-size: 20px;
    line-height: 1;
    opacity: 0.75;
    color: white;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.slick-prev {
    left: -25px;
}

[dir='rtl'] .slick-prev {
    right: -25px;
    left: auto;
}

.slick-prev:before {
    content: '←';
}

[dir='rtl'] .slick-prev:before {
    content: '→';
}

.slick-next {
    right: -25px;
}

[dir='rtl'] .slick-next {
    right: auto;
    left: -25px;
}

.slick-next:before {
    content: '→';
}

[dir='rtl'] .slick-next:before {
    content: '←';
}


/* Dots */

.slick-dotted.slick-slider {
    margin-bottom: 30px;
}

.slick-dots {
    position: absolute;
    bottom: 35px !important;
    display: block;
    width: 100%;
    padding: 0;
    margin: 0;
    list-style: none;
    text-align: center;
}

.slick-dots li button::before {
    color: #fff !important;
}

.slick-dots li {
    position: relative;
    display: inline-block;
    width: 20px;
    height: 20px;
    margin: 0 5px;
    padding: 0;
    cursor: pointer;
}

.slick-dots li button {
    font-size: 0;
    line-height: 0;
    display: block;
    width: 20px;
    height: 20px;
    padding: 5px;
    cursor: pointer;
    color: transparent;
    border: 0;
    outline: none;
    background: transparent;
}

.slick-dots li button:hover,
.slick-dots li button:focus {
    outline: none;
}

.slick-dots li button:hover:before,
.slick-dots li button:focus:before {
    opacity: 1;
}

.slick-dots li button:before {
    font-family: 'slick';
    font-size: 10px;
    line-height: 20px;
    position: absolute;
    top: 0;
    left: 0;
    width: 20px;
    height: 20px;
    content: '•';
    text-align: center;
    opacity: 0.25;
    color: #fff !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.slick-dots li.slick-active button:before {
    opacity: 0.75;
    color: black;
}

*/ .jet .mainside a {
    font-size: 30px;
    font-weight: 300;
    display: flex !important;
    align-items: center;
    gap: 15px;
    line-height: 50px !important;
}

.jet .mainside a:hover {
    color: #e3c39a;
}

.jet .mainside {
    padding: 0 !important;
    z-index: 99 !important;
    border-radius: 0px !important;
}

.jet .mainside .menu-item {
    padding: 0 !important;
}

.jet .flex-col1 {
    padding: 20% 10%;
    z-index: 99;
}

.jet .gold {
    width: 20px;
    height: 2px;
    background: #e3c39a;
}

.jet .column3 {
    z-index: 1;
    width: 800px !important;
    background: #3b6037 !important;
    padding: 12% 10%;
    border-radius: 0px !important;
}

.jet .column3 a {
    color: #fff !important;
    font-size: 30px !important;
    font-weight: 300;
}

.jet .side-flex {
    width: 800px !important;
    z-index: 1;
}

.jet .column3 img {
    width: 250px !important;
}

.jet .column-items {
    display: flex;
    align-items: center !important;
    gap: 40px;
    margin-bottom: 50px;
}

.jet .column3 p {
    text-align: left !important;
    color: #fff !important;
    font-size: 16px !important;
    font-weight: 300;
}

.jet .column3 .text {
    text-align: left !important;
}

.jet .column3 .text a {
    padding: 0 !important;
    font-size: 20px !important;
}

.jet .column3 .text a:hover {
    background: transparent !important;
    color: #e3c39a !important;
}

.jet .column3 .text p {
    margin-top: 15px !important;
}

.jet .column3 .menu-item {
    padding: 0px !important;
}

.slide-fade1-enter-active {
    transition: all 1s ease !important;
}

.slide-fade1-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0) !important;
}

.slide-fade1-enter,
.slide-fade1-leave-to
/* .slide-fade-leave-active below version 2.1.8 */

{
    transform: translateX(-700px) !important;
    opacity: 1;
}

.jet .mainside .menu-item a:after {
    content: '';
    position: absolute;
    width: 100%;
    transform: scaleX(0);
    height: 1px;
    bottom: 0;
    left: 0;
    background-color: transparent !important;
    transform-origin: bottom right;
    transition: transform 0.25s ease-out;
}

.jet .mainside .menu-item a:hover:after {
    transform: scaleX(1);
    transform-origin: bottom left;
}

.slick-slider {
    margin-left: 35px !important;
    margin-right: 25px !important;
    max-width: 100% !important;
    margin-left: auto !important;
    margin-right: auto !important;
    padding-top: 50px;
    cursor: pointer;
}

#slide0 {
    background-image: url(/wp-content/uploads/2023/07/neurolithiasi.webp) !important;
    background-position: center center !important;
}

#slide1 {
    background-image: url(/wp-content/uploads/2023/07/akrat.webp) !important;
    background-position: center center !important;
}

#slide2 {
    background-image: url(/wp-content/uploads/2023/07/std.webp) !important;
    background-position: center center !important;
}

#slide3 {
    background-image: url(/wp-content/uploads/2023/07/kroustika.webp)!important;
    background-position: center center !important;
}

#slide4 {
    background-image: url(/wp-content/uploads/2023/06/BG.jpeg)!important;
    background-position: center center !important;
}

#slide5 {
    background-image: url(/wp-content/uploads/2023/06/acupuncture-process-client-scaled.jpg) !important;
    background-position: center center !important;
}

#slide6 {
    background-image: url(/wp-content/uploads/2023/06/BG.jpeg)!important;
    background-position: center center !important;
}

#slide7 {
    background-image: url(/wp-content/uploads/2023/06/acupuncture-process-client-scaled.jpg)!important;
    background-position: center center !important;
}

.card_vue {
    background: #a71d54;
    padding: 200px;
    border-radius: 10px;
    width: 500px;
    height: 300px;
    margin-left: auto;
    margin-right: auto;
    color: #fff;
    margin-bottom: 20px;
    background-size: cover;
    position: relative;
}

.card_vue img {
    display: none !important;
}

.card_vue p {
    position: absolute;
    bottom: 0px;
    left: 0px;
    width: 100%;
    background: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0)), color-stop(35%, rgba(0, 0, 0, 0.15)), color-stop(75%, black));
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.15) 35%, black 75%);
    padding: 200px 46px 79px 46px;
    text-align: center;
    font-size: 20px;
}

.slick-next {
    background: #a71d54 !important;
    border-radius: 50% !important;
    color: #a71d54 !important;
    width: 40px;
    height: 40px;
    background: url(/wp-content/uploads/2023/03/right2.png) !important;
    background-size: cover !important;
    border: 3px solid #a71d54 !important;
}

.slick-prev {
    background: #a71d54 !important;
    border-radius: 50% !important;
    color: #a71d54 !important;
    height: 40px;
    width: 40px;
    background-image: url(/wp-content/uploads/2023/03/left2.png) !important;
    background-size: cover !important;
    border: 3px solid #a71d54 !important;
}

.slick-prev::before {
    content: "";
}

.slick-next::before {
    content: "";
}


/*  @media only screen and (max-width: 1300px) {
    .slick-slider{
      max-width: 85% !important;
    }
  }*/

@media only screen and (max-width: 600px) {
    .card_vue {
        width: 200px !important;
        height: 300px !important;
        padding: 150px !important;
    }
}

@media only screen and (max-width: 450px) {
    .card_vue {
        padding: 100px !important;
        height: 250px !important;
    }
}

.card_vue1 {
    background: #e6f2ff;
    height: 350px;
    margin-left: auto;
    margin-right: auto;
    color: #fff;
    margin-bottom: 20px;
    background-size: cover;
    position: relative;
    width: 99%;
}

.card_vue1 p {
    font-size: 16px;
    color: rgb(121 121 121);
    padding-bottom: 45px;
}

.card_vue1 h2 {
    font-size: 17px;
    color: rgb(0 0 0);
}

.card_vue1 h3 {
    font-size: 16px;
    color: #3bafaf;
    padding-bottom: 15px;
    margin-bottom: 0px !important;
}

.card_vue1 p {
    margin-bottom: 0px !important;
}

.slider-new .slick-next {
    border-radius: 0% !important;
    color: #4480af !important;
    width: 40px;
    height: 40px;
    background-size: cover !important;
    border: 2px solid #134062 !important;
    position: absolute;
    left: 93%;
    z-index: 999;
    margin-top: -130px;
    top: 80%;
}

.slider-new .slick-prev {
    background: #4480af !important;
    border-radius: 0% !important;
    color: #4480af !important;
    height: 40px;
    width: 40px;
    background: url(/wp-content/uploads/2023/03/left2.png) !important;
    background-size: cover !important;
    border: 2px solid #134062 !important;
    position: absolute;
    left: 5%;
    z-index: 999;
    margin-top: -130px;
    top: 80%;
}

.slick-slider {
    margin-left: 0px !important;
    margin-right: 0px !important;
    padding-top: 50px;
    cursor: pointer;
}

.slider-new .slick-prev:hover {
    background: url('/wp-content/uploads/2023/03/left1.png'), #134062 !important;
    background-size: cover !important;
}

.slider-new .slick-next:hover {
    background: url('/wp-content/uploads/2023/03/right1.png'), #134062 !important;
    background-size: cover !important;
}

.fade-in {
    width: 100px;
    height: 100px;
    opacity: 0.00;
    -webkit-transition: 1s all ease-in-out;
    -moz-transition: 1s all ease-in-out;
    -o-transition: 1s all ease-in-out;
    transition: 1s all ease-in-out;
}

.fade-in:hover {
    opacity: 1.00;
}

.side-info {
    padding: 0px 10px !important;
    background-color: rgba(255, 255, 255, 0.9) !important;
    width: 100% !important;
    height: 20% !important;
    position: absolute !important;
    left: 0px !important;
    bottom: 0px !important;
    text-align: center !important;
    opacity: 0 !important;
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
}

.side-info h2 {
    margin-bottom: 0px !important;
}

.slick-current .side-info {
    opacity: 1 !important;
}

.side-info a {
    background-color: #3bafaf;
    color: #fff !important;
    border: none;
    color: white !important;
    padding: 10px 35px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    border-radius: 5px;
    font-weight: bold;
}

.side-info a:hover {
    background-color: #e0a291;
}

.side-info hr {
    border: 2px solid #3bafaf !important;
    border-radius: 0px;
    width: 50px;
    margin: 25px 0;
}


/* @media only screen and (max-width: 1600px) {
    .side-info a{
      font-size:14px !important;
    }
	.slider-new .slick-prev{
		 left: 48%; 
	}
  }
@media only screen and (max-width: 1450px) {
	.side-info a{
		padding: 10px 25px;
	}
  }
 @media only screen and (max-width: 1400px) {
	.slider-new .slick-prev{
		 left: 47.6%; 
	}
	 .slider-new .slick-next{
		 left: 50.5%;
	 }
  }
@media only screen and (max-width: 1310px){
	.side-info {
		width: 25vw !important;
	}
	.slider-new .slick-prev {
		left: 26.7% !important;
	}
	.slider-new .slick-next {
		left: 29.8% !important;
	}
}*/

@media only screen and (max-width: 1750px) {
    .card_vue1 {
        height: 350px !important;
    }
}

@media only screen and (max-width: 1600px) {
    .side-info a {
        font-size: 14px !important;
    }
}

@media only screen and (max-width: 1500px) {
    .left {
        left: 30px;
    }
    .right {
        right: 30px;
    }
}

@media only screen and (max-width: 1400px) {
    .card_vue1 p {
        font-size: 15px;
    }
}

@media only screen and (max-width: 1350px) {
    .hero-header h3,
    .hero-header p,
    .hero-header {
        text-align: center;
    }
    .hero-header {
        left: 50% !important;
    }
    .left {
        left: 55px;
    }
    .right {
        right: 55px;
    }
    .card_vue1 {
        height: 350px !important;
    }
}

@media only screen and (max-width: 1300px) {
    .menu-col1 {
        padding-right: 100px!important;
    }
    .menu-col {
        padding-left: 100px !important;
    }
    .new-slider .slick-slider {
        max-width: 100% !important;
        width: 100% !important;
    }
}

@media only screen and (max-width: 900px) {
    .first-text h1 {
        font-size: 30px !important;
    }
    .secont-text h1 {
        font-size: 25px !important;
    }
    .hero-header p {
        font-size: 25px !important;
    }
    .hero-header h3 {
        font-size: 50px !important;
        margin-bottom: 20px !important;
    }
    .hero-header {
        width: 630px !important;
    }
}


/*@media only screen and (max-width: 800px) {	
  .slider-new .slick-next{
    left: 52%;
  }
  .slider-new .slick-prev{
    left: 45.8%;
  }
}*/

@media only screen and (max-width: 750px) {
    .first-text h1,
    .first-text p {
        font-size: 25px !important;
    }
    .second-text p,
    .second-text h1 {
        font-size: 22px !important;
    }
}

@media only screen and (max-width: 600px) {
    .hero-header p {
        font-size: 20px !important;
    }
    .hero-header h3 {
        font-size: 40px !important;
        margin-bottom: 10px !important;
    }
    .hero-header {
        width: 450px !important;
    }
    .left {
        left: 25px;
    }
    .right {
        right: 25px;
    }
    /*.slider-new .slick-next{
    left: 53%;
  }
  .slider-new .slick-prev{
    left: 44.8%;
  }*/
    .slider-new .slick-prev,
    .slider-new .slick-next {
        top: 86% !important;
    }
    .card_vue1 {
        height: 300px !important;
    }
    .first-text h1,
    .first-text p {
        font-size: 25px !important;
    }
}

@media only screen and (max-width: 550px) {
    .card_vue1 {
        height: 300px !important;
    }
}

@media only screen and (max-width: 500px) {
    .hero-header {
        width: 350px !important;
    }
    /*	.slider-new .slick-next{
    left: 55%;
  }
  .slider-new .slick-prev{
    left: 40.8%;
  }*/
    .first-text h1,
    .first-text p {
        font-size: 22px !important;
    }
    .first-text {
        margin-bottom: 60px !important;
    }
    .new-slider {
        margin-left: 10px !important;
        margin-right: 10px !important;
    }
    .card_vue1 {
        height: 300px !important;
    }
    .second-text p,
    .second-text h1 {
        font-size: 20px !important;
    }
    .slider-new .slick-next {
        left: 83.5%;
    }
    .hero-header p {
        font-size: 18px !important;
        line-height: 35px !important;
    }
    .hero-header h3 {
        font-size: 30px !important;
        margin-bottom: 0px !important;
    }
}

@media only screen and (max-width: 470px) {
    .first-text h1,
    .first-text p {
        font-size: 20px !important;
    }
    .secont-text p,
    .secont-text h1 {
        font-size: 18px !important;
    }
}

@media only screen and (max-width: 450px) {
    .hero-header h3 {
        font-size: 25px !important;
    }
    #slide0 {
        background-position: center !important;
    }
    #slide1 {
        background-position: center !important;
    }
    #slide2 {
        background-position: center !important;
    }
    #slide3 {
        background-position: center !important;
    }
    .first-text h1,
    .first-text p {
        font-size: 20px !important;
    }
    .first-text p {
        font-size: 20px !important;
    }
    .card_vue1 h2 {
        font-size: 15px !important;
    }
    .second-text p,
    .second-text h1 {
        font-size: 18px !important;
    }
    .hero-header {
        top: 55% !important;
    }
    .carousel-control {
        top: 50% !important;
    }
    .carousel-control svg {
        width: 10px !important;
    }
    .left {
        left: 5px !important;
    }
    .right {
        right: 5px !important;
    }
}

@media only screen and (max-width: 430px) {
    .first-text p {
        font-size: 18px !important;
    }
    .secont-text p,
    {
        font-size: 17px !important;
    }
    .hero-header {
        width: 320px !important;
    }
}

@media only screen and (max-width: 371px) {
    .card_vue1 h2 {
        font-size: 14px !important;
    }
}

@media only screen and (max-width: 350px) {
    .hero-header {
        width: 280px !important;
    }
    .first-text h1,
    .first-text p {
        font-size: 18px !important;
    }
    .secont-text p,
    .secont-text h1 {
        font-size: 17px !important;
    }
}

@media only screen and (max-width: 340px) {
    .first-text h1,
    .first-text p {
        font-size: 18px !important;
    }
    .secont-text p,
    .secont-text h1 {
        font-size: 17px !important;
    }
    .first-text p {
        font-size: 16px !important;
    }
    .secont-text p {
        font-size: 15px !important;
    }
    .card_vue1 h2 {
        font-size: 13.5px !important;
    }
}

@media only screen and (max-width: 330px) {
    .card_vue1 h2 {
        font-size: 13px !important;
    }
}

.slick-dots {
    bottom: 35px !important;
}

.nav {
    display: flex;
    align-items: center;
}

.sidebar-drop {
    position: fixed !important;
    left: 0px;
    top: 100px !important;
}

nav .menu-item {
    color: #fff;
    position: relative;
    text-align: center;
    border-bottom: 3px solid transparent;
    display: flex;
    transition: 0.4s;
}

nav .menu-item a {
    color: inherit;
    text-decoration: none;
}

.img-text {
    display: flex;
    padding-left: 40px;
    margin-bottom: 25px;
}

.menu-col {
    width: 100% !important;
    padding-top: 30px !important;
    padding-left: 40px !important;
	padding-right: 40px !important;
}

.menu-col1 {
    width: 100% !important;
    padding-right: 40px !important;
	padding-left: 40px !important;
    /*border-left: 1px solid #e5e5e5;*/
    padding-top: 25px;
    padding-bottom: 25px;
}

.menu-item1 {
    display: flex;
}

.dropdown {
    text-align: center;
}

.button-dropdown {
    font-size: 40px;
    text-decoration: none;
    color: #222 !important;
    display: inline-block;
    position: relative;
}

.button-dropdown:hover:after {
    transform: scaleX(1);
    transform-origin: bottom left;
}

.button-dropdown svg {
    margin-left: 10px;
    width: 15px !important;
    filter: none !important;
}

.menu-item svg {
    width: 10px !important;
}

.menu-btn {
    padding-left: 10px !important;
}

.sidebar-drop img {
    width: 120px !important;
    height: 90px !important;
    min-width: 120px !important;
    object-fit: cover;
    border-radius: 5px !important;
}
.sidebar-drop a:hover{
	color:#1d6aa4 !important;
}
.title-text {
    margin-left: 15px !important;
}
.marg{
	margin-top:40px !important;
}
.side-cont {
    border-top: 1px solid #e7e7e7;
    background-color: #fbfef9;
    width: 100% !important;
    height: 530px !important;
	padding-bottom:0px !important;
    z-index: 99;
    /*box-shadow: 1px 3px 3px rgb(0 0 0 / 21%);*/
    border-radius: 0px !important;
    margin-left: auto;
    margin-right: auto;
    text-align: left;
    padding: 0px 0;
    margin-top: 0px;
    overflow: hidden;
    display: flex;
    overflow-x: hidden;
    overflow-y: scroll;
}

.sidebar-drop {
    border-radius: 0px !important;
    background-color: transparent !important;
    width: 100% !important;
    height: max-content !important;
    z-index: 99;
    /*box-shadow: 1px 3px 3px rgb(0 0 0 / 21%);*/
    margin-left: auto;
    margin-right: auto;
    text-align: left;
    padding: 0px 0;
    margin-top: 0px;
    overflow: hidden;
    display: flex;
}

.title-text p {
    color: #000 !important;
    font-size: 14px !important;
}

.title-text a {
    line-height: 20px !important;
    padding-bottom: 15px !important;
}

.title-text a {
    margin-left: 0px !important;
    padding-left: 0px !important;
    text-align: left !important;
}

.sidebar-drop .menu-item1 {
    font-size: 20px;
    padding: 9px 40px;
    font-weight: 600;
}

.sidebar-drop .menu-item1 a {
    text-align: left;
    text-decoration: none;
    color: #222;
    display: inline-block;
    padding-bottom: 5px;
    position: relative;
}

.title-text a {
    text-decoration: none;
    color: #222 !important
}

.title-text a:hover {
    color: #1c6aa3 !important
}

.sidebar-drop .menu-item1 a:hover:after {
    transform: scaleX(1);
    transform-origin: bottom left;
}

.sidebar-drop.menu-item1:hover {
    background-color: #fff;
    color: #222;
}

.sidebar-drop .menu-item1 a:hover {
    color: #1c6aa3 !important
}

.slide-up-enter-active,
.slide-up-leave-active {
    transition: all 0.4s ease-out;
}

.slide-up-enter,
.slide-up-leave-to {
    opacity: 0;
    transform: translateY(30px);
}

@media only screen and (max-width: 1700px) {
    .menu-col,
    .menu-col1 {
        width: 50% !important;
    }
}

@media only screen and (max-width: 1500px) {
    .menu-col {
        padding-left: 150px !important;
    }
    .menu-col1 {
        padding-right: 150px !important;
    }
}

@media only screen and (max-width: 1250px) {
    .side-cont {
        margin-top: 115px!important;
    }
    .menu-col {
        padding-left: 100px !important;
    }
    .menu-col1 {
        padding-right: 100px !important;
    }
}

@media only screen and (max-width: 1150px) {
    .menu-col {
        padding-left: 50px !important;
    }
    .menu-col1 {
        padding-right: 50px !important;
    }
    .title-text a {
        padding-left: 0px !important;
    }
}

@media only screen and (max-width: 1060px) {
    .side-cont {
        margin-top: 108px !important;
    }
    .menu-col {
        width: 40% !important;
    }
    .menu-col1 {
        width: 60% !important;
    }
}

@media only screen and (max-width: 767px) {
    nav .menu-item1 .sidebar {
        width: 100% !important;
    }
}


.active {
    opacity: 1;
}

.bottom-header h3 {
    font-weight: 500 !important;
    font-size: 22px !important;
    margin-bottom: 10px !important;
    font-family: "ZonaPro" !important;
}

.bottom-header {
    margin-bottom: 130px !important;
}

.bottom-header p {
    font-weight: 300 !important;
    font-size: 17px !important;
    font-family: "ZonaPro" !important;
}

.bottom-header a {
    font-family: "ZonaPro" !important;
    border-radius: 5px !important;
    box-shadow: -2px 2px 12px rgb(0 0 0 / 17%);
    padding: 15px 30px 15px 30px;
    color: RGBA(80, 124, 41, 1);
    border: 1px solid #507c29 !important;
    text-decoration: none;
    color: #507c29 !important;
}

.bottom-header a:hover {
    background: #507c29 !important;
    color: #fff !important;
}

.bottom-header {
    align-items: center !important;
    color: black !important;
}

.bottom-header {
    display: flex !important;
}

.bottom-header .column1 {
    margin-top: 20px !important;
    width: 70% !important;
}

.bottom-header .column2 {
    width: 30% !important;
}


@media only screen and (max-width: 600px) {
   
    .bottom-header {
        text-align: center;
        display: flex !important;
        flex-direction: column;
        align-items: center !important;
    }
    .bottom-header h3 {
        font-size: 20px !important;
    }
    .bottom-header p,
    .bottom-header a {
        font-size: 16px !important;
    }
   
    .bottom-header .column2,
    .bottom-header .column1 {
        width: 100% !important;
    }
}

</style>